import type { JSX, PropsWithChildren } from "react";

import { useReducedMotion } from "react-native-reanimated";

import { FadeInUpView } from "@/ui/layout/animated/FadeInUpView";

interface AnimatedSectionProps extends PropsWithChildren {
  delay?: number;
}

/** Reduced-motion-aware entrance wrapper. Wraps children in FadeInUpView when motion is allowed, renders directly otherwise. */
const AnimatedSection = ({
  children,
  delay = 0,
}: AnimatedSectionProps): JSX.Element => {
  const isReducedMotion = useReducedMotion();

  if (isReducedMotion) {
    // eslint-disable-next-line react/jsx-no-useless-fragment -- consistent return type
    return <>{children}</>;
  }

  return <FadeInUpView delay={delay}>{children}</FadeInUpView>;
};

export type { AnimatedSectionProps };
export { AnimatedSection };
